<template>
  <v-row style="margin-left: 5%;margin-right: 5%;">
    <span class="centered">{{ elementName }}</span>

    <v-spacer></v-spacer>
    <v-switch
      class="centered"
      v-model="elementValue"
      :disabled="disabled"
      flat
      @click="updateValue({ elementName, elementValue })"
    ></v-switch>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      elementValue: false
    }
  },
  props: {
    elementName: String,
    value: Boolean,
    disabled: Boolean,
  },
  methods: {
    updateValue(name, value) {
      this.$emit('updateSwitchValue', { name: name, value: value })
    },
  },
  async mounted() {
    this.elementValue = this.value
  },
}
</script>

<style scoped>
.centered {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
}
</style>